module.exports = __webpack_public_path__ + "img/setting_icon.7038d8db.svg";